export const veryLowValueDivCards: string[] = []
export const lowValueDivCards: string[] = []
